
import BaseVPlusWidget from '../../../../base/components/sidebar/widgets/VPlusWidget.vue'

export default class VPlusWidget extends BaseVPlusWidget {}
